





















import moment from 'moment-timezone'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    dateFormat: {
      type: String,
      default: 'Do MMMM, YYYY',
    },
    label: {
      type: String,
      required: true,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    displayValue() {
      return moment(this.value).format(this.dateFormat)
    },
  },
}
